// extracted by mini-css-extract-plugin
export default {"footer":"DetailLayout_footer__yXZPg"};